import Parent from "./Parent";
import Children from "./Children";
import Spouses from "./Spouses";
import EmergencyContact from "./EmergencyContact";
import PermanentAddress from "./PermanentAddress";
import PresentAddress from "./PresentAddress";
import Ration from "./Ration";

export {
  Parent,
  Children,
  Spouses,
  EmergencyContact,
  PermanentAddress,
  PresentAddress,
  Ration,
};
